import { NodeState, TreeViewState } from '@/logic/tree'
import { TreeDataProvider } from '@/logic/treeData'
import { loadAtlasTree, renderAtlasTree } from './renderAtlas'
import { loadPassiveTree, renderPassiveTree } from './renderPassives'
import { Renderer } from './renderer'

export function frameColor(state: NodeState) {
  switch (state) {
    case 'add':
    case 'addHistory':
      return { r: 0.0, g: 1.0, b: 0.0, a: 1.0 }
    case 'remove':
    case 'removeHistory':
      return { r: 1.0, g: 0.125, b: 0.125, a: 1.0 }
  }
}

export const InteractAscendancy = -1
export const InteractAscendancyButton = -2

export function lineState(node1: NodeState, node2: NodeState) {
  if (node1 === 'active' && node2 === 'active') {
    return 'active'
  } else if ((node1 === 'remove' || node1 === 'removeHistory') && node2) {
    return 'remove'
  } else if ((node2 === 'remove' || node2 === 'removeHistory') && node1) {
    return 'remove'
  } else if ((node1 === 'add' || node1 === 'addHistory') && node2) {
    return 'add'
  } else if ((node2 === 'add' || node2 === 'addHistory') && node1) {
    return 'add'
  }
}

export function renderTree(
  data: TreeDataProvider,
  ascendancyButton?: 'hover' | 'pressed'
) {
  return data.atlas
    ? renderAtlasTree(data)
    : renderPassiveTree(data, ascendancyButton)
}

export function loadTree(tree: TreeViewState, renderer: Renderer) {
  return 'atlas' in tree
    ? loadAtlasTree(tree, renderer)
    : loadPassiveTree(tree, renderer)
}
